import { Injectable, InjectionToken } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { User } from 'src/app/model/user';
import { Patient } from 'src/app/model/patient';
import { UserWebResponse } from 'src/app/model/user-web-response';
import { DeviceSetting } from 'src/app/model/device-setting';
import { Data } from 'src/app/model/data';

@Injectable()
export abstract class GlobalDeviceService {
    abstract getGlobalDeviceList(): Observable<any>;
    abstract getGatewaynodeList(): Observable<any>;
    abstract getGatewayregisterList(): Observable<any>;
    abstract getOtaList(): Observable<any>;
    abstract getApkList(): Observable<any>;
    abstract getOtaById(ota_upload_id): Observable<any>;
    abstract addOta(otaUpload): Observable<any>;
    abstract addApk(apkUpload): Observable<any>;
    abstract getImportPatientList(): Observable<any>;
    abstract getAllUserPatientList(): Observable<any>;
    abstract getVaUserPatientList(): Observable<any>;
    abstract importGlobalDevice(file): Observable<any>;
    abstract importImportPatient(file): Observable<any>;
    abstract getCloudDeviceHistoryList(): Observable<any>;
    abstract getDisablePressureSerialList(): Observable<any>;
    abstract addGlobalDevice(device): Observable<any>;
    abstract addGatewaynode(device): Observable<any>;
    abstract addGatewayregister(device): Observable<any>;
    abstract editGatewayregister(device): Observable<any>;
    abstract deleteGlobalDevice(devicelist): Observable<any>;
    abstract deleteGatewaynode(devicelistDelete): Observable<any>;
    abstract deleteGatewayregister(gatewayRegisterListDelete): Observable<any>;
    abstract addCloudDeviceHistory(device): Observable<any>;
    abstract addDisablePressure(device): Observable<any>;
    abstract editCloudDeviceHistory(device): Observable<any>;
}